import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import styles from "./styles.module.css";

export default class Modal extends React.Component {
  render() {
    const light = this.props.light || false;
    return (
      <div
        className={`${styles.modal} ${
          this.props.isOpenModal ? "block" : "hidden"
        }`}
      >
        <div className={styles.wrap_modal_content}>
          <div className={`${styles.modal_content} ${light ? 'bg-gray-100 text-black' : 'bg-black text-white'}`} >

            {this.props.closeModal && <AiOutlineClose
                className={styles.close_icon}
                color={light ? 'black' : 'white'}
                onClick={this.props.closeModal}
            />}

            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
